import React, { useEffect, useState } from 'react';
import { ProductDetail } from './ProductDetail';
import { ContentHeader, Error, Table } from '@app/shared';
import { ComponentErrorBoundary } from '@app/utilities';
import { useGetProduct, useProductWithHierarchy } from '@app/sdk';
import { useGlobalContext } from '../../../GlobalContextProvider';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';
import { UpdateConfig } from '../updateConfig/UpdateConfig';
import { AddConfig } from '../addConfig/AddConfig';

export function Products() {
  const [selectedProductId, setSelectedProductId] = useState(undefined as any);
  const [isUpdateConfig, setIsUpdateConfig] = useState(false);
  const [isAddConfig, setIsAddConfig] = useState(false);
  const { tenantId } = useGlobalContext();
  const { isLoading: loading, data: products, error } = useProductWithHierarchy();

  useEffect(() => {
    setSelectedProductId(undefined);
  }, [tenantId]);

  const { data: selectedProduct } = useGetProduct({ productId: selectedProductId });

  const columnDefs: ColDef[] = [
    { field: 'productId', headerName: 'ID' },
    { field: 'label', headerName: 'Label' },
    { field: 'parent.name', headerName: 'Parent OU' },
  ];

  const master = (
    <Segment style={{ height: '100%' }}>
      <ContentHeader>
        Products
        <div>
          <button
            disabled
            className="ui button primary"
            onClick={() => {
              setIsAddConfig(true);
              setIsUpdateConfig(false);
            }}>
            Add Config
          </button>
          <button
            disabled
            className="ui button primary"
            onClick={() => {
              setIsUpdateConfig(true);
              setIsAddConfig(false);
            }}>
            Edit Config
          </button>
        </div>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 70px)' }}>
        <Table
          items={products}
          onSelectItem={(product) => setSelectedProductId(product.productId)}
          columnDefs={columnDefs}
        />
      </div>
    </Segment>
  );

  const updateConfig = (
    <Segment>
      <UpdateConfig
        key={selectedProductId}
        enableEditConfig={setIsUpdateConfig}
        item={selectedProduct}
        type={'product'}
      />
    </Segment>
  );

  const addConfig = (
    <Segment>
      <AddConfig key={selectedProductId} enableAddConfig={setIsAddConfig} item={selectedProduct} type={'product'} />
    </Segment>
  );

  const productDetail = (
    <>
      <Segment>
        {selectedProductId ? <ProductDetail product={selectedProduct} /> : <section>Please select a product</section>}
      </Segment>
    </>
  );

  return (
    <ComponentErrorBoundary>
      {error && <Error error={error} />}
      {loading && <div className="ui active centered inline loader" />}
      {!loading && products && (
        <MasterDetailLayout
          master={master}
          detail={isUpdateConfig ? updateConfig : isAddConfig ? addConfig : productDetail}
        />
      )}
    </ComponentErrorBoundary>
  );
}
